// TODO: 同様の処理が多数の場所にあるので共通化する
// server/libs/date.ts にある一部のフォーマット系関数もここにおいてもいいかも

const toYmd = (d: Date | string): string => {
  const date = new Date(d);
  return `${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`;
};

export const dateToYmd = (date: Date): string => toYmd(date);

export const isoStringToYmd = (isoString: string): string => toYmd(isoString);
